import { Input } from "antd";
import axios from "axios";
import React, { useState } from "react";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import { Error, Success } from "../../../commons/Messages/Messages";
import GeneralModal from "../General.modal";
import { useTranslation } from "react-i18next";

const AddMeetings = ({ updateParent }) => {
  const { t } = useTranslation("dashboard");
  const [meetingName, setMeetingName] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = async e => {
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/meetings/create`,
        { meetingName },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          handleCancel();
          updateParent();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        if (err?.response && err?.response?.data && err?.response?.data?.errors) {
          const validationErrors = err?.response?.data?.errors;
          const errorMessage = Object.values(validationErrors)
            ?.map(err => `${err?.path} is ${err?.kind}.`)
            .join("\n");
          Error(errorMessage);
        } else if (err?.response?.data?.keyPattern) {
          Error(Object.keys(err?.response?.data?.keyPattern) + " already exists");
        } else {
          Error(err.message);
        }
      });
  };

  const items = (
    <Input
      className="mt-3"
      type="text"
      placeholder={t("Title")}
      aria-label={t("Title")}
      value={meetingName}
      onChange={e => setMeetingName(e.target.value)}
    />
  );

  return (
    <div className="AddMeetings">
      <MainButtonComp text="Add Meeting" addBtn onClick={showModal} />
      <GeneralModal
        title={t("Add Meeting")}
        onOk={() => onSubmit()}
        open={isModalOpen}
        okText={t("Create")}
        onCancel={handleCancel}
        items={items}
        modalminheight={2}
      />
    </div>
  );
};

export default AddMeetings;
